import * as React from "react";
import type { SVGProps } from "react";
const SvgToogleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M7.2 16.8h9.6a4.8 4.8 0 1 0 0-9.6H7.2m0 9.6a4.8 4.8 0 1 1 0-9.6m0 9.6a4.8 4.8 0 1 0 0-9.6"
    />
  </svg>
);
export default SvgToogleLeft;
